import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LoginComponent } from '@app/components/account/login/login.component';
import { RegisterComponent } from '@app/components/account/register/register.component';
import { WelcomeComponent } from '@app/components/welcome/welcome.component';
import { AuthService } from '@app/services/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, snapshot: RouterStateSnapshot): boolean {
    var url = snapshot.url;
    return this.isAuthenticated(url);
  }

  isAuthenticated(url: string): boolean {
    var isSignIn =
      url.startsWith(`/${LoginComponent.route}`) || url.startsWith(`/${RegisterComponent.route}`);

    if (this.authService.isAuthenticated()) {
      if (isSignIn) {
        this.router.navigate([`/${WelcomeComponent.route}`]);
      }
      return !isSignIn;
    }

    if (!isSignIn) {
      this.router.navigate([`/${LoginComponent.route}`], { queryParams: { returnUrl: url } });
    }

    return isSignIn;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guards/auth-guard.service.ts